<template>
    <v-text-field
      v-model="internal_value"
      v-bind="{...$attrs, ...$props}"
      v-on="$listeners"
      :rules="validationRules"
      :outlined="outlined"
      :prepend-inner-icon="prependIcon"
    >
      <slot />
    </v-text-field>
  </template>
  
  <script>
  export default {
    name: "HjTextField",
    props : {
      value : {
        required : false
      },
  
      validationText : {
        required : false,
        type : String,
        default : 'Field is required'
      },
  
      required : {
        required : false,
        type : Boolean,
        default : false
      },
  
      phone : {
        required : false,
        type : Boolean,
        default : false,
      },
  
      email : {
        required : false,
        type : Boolean,
        default : false
      },
  
      minLength : {
        required : false,
        type : Number,
        default : 0
      },
  
      maximumLength : {
        required : false,
        type : Number,
        default : 0
      },
  
      icon : {
        required : false,
        type : String,
        default : ''
      },
      outlined: {
        required : false,
        type : [Boolean, String],
        default : ''
      }
    },
  
    computed : {
      internal_value : {
        get(){
          return this?.value ? this.value : null
        },
        set(val){
          this.$emit('input', val)
        }
      },
  
      prependIcon(){
        if ( this.phone ) return 'mdi-phone'
        if ( this.email ) return 'mdi-email-outline'
        if ( this.icon ) return this.icon
  
        return null
      },
  
      validationRules(){
        let rules = []
        if ( this.required ){
          rules.push(v => (!!v && !Array.isArray(v)) || v === 0 || (Array.isArray(v) && v.length > 0) || this.validationText)
        }
  
        if ( this.phone ){ 
          rules.push(v => !!v || 'Phone Number is required')
          rules.push(v => (v && v.replace(/\D/g, '').length === 10) || 'Phone Number must be 10 digits')
        }
  
        if ( this.email ){
          rules.push(v => new RegExp('.+@.+').test(v) || 'E-mail must be valid')
          rules.push(v => (v && v.length <= 254) || 'Email must be less than 254 characters')
        }
  
        if ( this.minLength && this.minLength > 0 ){
          rules.push(v => (v && v.length >= this.minLength) || 'Must be at least ' + this.minLength + ' characters')
        }
  
        if ( this.maximumLength && this.maximumLength > 0 ){
          rules.push(v => (v && v.length <= this.maximumLength) || 'Cannot be more than ' + this.maximumLength + ' characters')
        }
  
        return rules;
      }
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  